import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10 2C8.89543 2 8 2.89543 8 4V6.33579C8 6.86622 8.21071 7.37493 8.58579 7.75L10.7626 9.92678C11.446 10.6102 12.554 10.6102 13.2374 9.92678L15.4142 7.75C15.7893 7.37493 16 6.86622 16 6.33579V4C16 2.89543 15.1046 2 14 2H10Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M22.0018 10C22.0018 8.89543 21.1064 8 20.0018 8H17.6661C17.1356 8 16.6269 8.21071 16.2518 8.58579L14.0751 10.7626C13.3916 11.446 13.3916 12.554 14.0751 13.2374L16.2518 15.4142C16.6269 15.7893 17.1356 16 17.6661 16H20.0018C21.1064 16 22.0018 15.1046 22.0018 14V10Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16 20V17.6642C16 17.1338 15.7893 16.6251 15.4142 16.25L13.2374 14.0732C12.554 13.3898 11.446 13.3898 10.7626 14.0732L8.58579 16.25C8.21071 16.6251 8 17.1338 8 17.6642V20C8 21.1046 8.89543 22 10 22H14C15.1046 22 16 21.1046 16 20Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M2 14C2 15.1046 2.89543 16 4 16H6.33579C6.86622 16 7.37493 15.7893 7.75 15.4142L9.92678 13.2374C10.6102 12.554 10.6102 11.446 9.92678 10.7626L7.75 8.58579C7.37493 8.21071 6.86622 8 6.33579 8H4C2.89543 8 2 8.89543 2 10V14Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }